import { withSvgIcon } from './withSvgIcon';

export const NavBarAdvancedApi = withSvgIcon(
  <>
    <path
      d="M9.10002 4L5.03258 5.83135C4.09983 6.25132 3.50002 7.1792 3.50002 8.20213V16.2134C3.50002 17.2363 4.09983 18.1642 5.03258 18.5842L9.10002 20.4155V19.0995L5.52524 17.49C5.02299 17.2638 4.70002 16.7642 4.70002 16.2134V8.20213C4.70002 7.65132 5.02299 7.1517 5.52524 6.92556L9.10002 5.31603V4Z"
      fill="currentColor"
    />
    <path
      d="M14.9 4L18.9675 5.83135C19.9002 6.25132 20.5 7.1792 20.5 8.20213V16.2134C20.5 17.2363 19.9002 18.1642 18.9675 18.5842L14.9 20.4155V19.0995L18.4748 17.49C18.977 17.2638 19.3 16.7642 19.3 16.2134V8.20213C19.3 7.65132 18.977 7.1517 18.4748 6.92556L14.9 5.31603V4Z"
      fill="currentColor"
    />
    <path
      d="M8.00001 13.3261L16 9.5V10.8302L8.00001 14.6563V13.3261Z"
      fill="currentColor"
    />
    <path
      d="M9.10002 4L5.03258 5.83135C4.09983 6.25132 3.50002 7.1792 3.50002 8.20213V16.2134C3.50002 17.2363 4.09983 18.1642 5.03258 18.5842L9.10002 20.4155V19.0995L5.52524 17.49C5.02299 17.2638 4.70002 16.7642 4.70002 16.2134V8.20213C4.70002 7.65132 5.02299 7.1517 5.52524 6.92556L9.10002 5.31603V4Z"
      stroke="currentColor"
      strokeWidth="0.3"
    />
    <path
      d="M14.9 4L18.9675 5.83135C19.9002 6.25132 20.5 7.1792 20.5 8.20213V16.2134C20.5 17.2363 19.9002 18.1642 18.9675 18.5842L14.9 20.4155V19.0995L18.4748 17.49C18.977 17.2638 19.3 16.7642 19.3 16.2134V8.20213C19.3 7.65132 18.977 7.1517 18.4748 6.92556L14.9 5.31603V4Z"
      stroke="currentColor"
      strokeWidth="0.3"
    />
    <path
      d="M8.00001 13.3261L16 9.5V10.8302L8.00001 14.6563V13.3261Z"
      stroke="currentColor"
      strokeWidth="0.3"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
